import store from '@/store';
export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 5,
    searchMenuSpan: 4,
    border: true,
    index: true,
    viewBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    dialogClickModal: false,
    searchLabelWidth: 100,
    column: [{
            label: "主键id",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "进件编号",
            prop: "businessCode",
            type: "input",
            search: true,
            searchOrder: 444,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            type: "input",
        },
        {
            label: "产品类型",
            prop: "rentType",
            type: "select",
            dicData: store.getters.porductTypes
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            search: true,
            searchOrder: 888,
            searchMultiple: true,
            hide: true,
            showColumn: false,
            dicData: store.getters.porductTypes
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: "true",
            searchOrder: 777,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            type: "input",
        },
        {
            label: "租赁金额",
            prop: "lendingAmount",
            type: "input",
        },
        {
            label: "每月租金",
            prop: "lendingAmountPer",
            type: "input",
        },
        {
            label: "客户期数",
            prop: "currentTenancy",
            type: "input",
            formatter: (val, value, label) => {
                return value ? (value + "/" + val['tenancy']) : "-";
            },
        },
        {
            label: "结清金额",
            prop: "settlementAmount",
            type: "input",
        },
        {
            label: "实际结清金额",
            prop: "hadSettlementAmount",
            type: "input",
        },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            type: "input",
            search: true,
            searchOrder: 555,
        },
        {
            label: "结清时间",
            prop: "settlementTimeRange",
            type: "date",
            // search: true,
            searchRange: true,
            hide: true,
            showColumn: false,
            searchType: "daterange",
            valueFormat: "yyyy-MM-dd",
        },
        {
          label: "结清收款类型",// 新增字段
          prop: "needReceiveFundTypeString",
          type: "input",
        },
        {
          label: "结清类型",// 新增字段
          prop: "settlementType",
          searchOrder: 666,
          type: "select",
          search: true,
          hide: true,
          dicData: [
            {
              label: "客户违约结清",
              value: 1,
            },
            {
              label: "代理商违约结清",
              value: 2,
            },
          ],
        },
    ]
};
